import axios from "axios";

export default {
  namespaced: false,
  state: {
    status: "",
    // userClaims: "",
    isLoggedIn: false,
    // isManager:false,
    // isLabUser:false,
    // tenants:[],
  },
  mutations: {
    auth_success(state) {
      state.status = "success";
    //   state.userClaims = userClaims
      state.isLoggedIn = true;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.user = null;
      state.isLoggedIn = false;
    //   state.programs = [];
    //   state.selectedProgram = null;
    //   state.programEdited = null;
    //   state.tenants=[];
    },
    // set_manager(state, value) {
    //   state.isManager = value
    // },
    // set_labuser(state, value) {
    //   state.isLabUser = value
    // },
    // set_tenants(state, value) {
    //   state.tenants = value
    // }
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    authStatus: state => state.status,
    // user: state => state.userClaims,
    // name: state => state.userClaims['name'],
    // program :state => state.userClaims,
    // selectedProgram:state => state.selectedProgram,
    // programEdited:state => state.programEdited,
    // isManager: state => state.isManager,
    // isLabUser: state => state.isLabUser,
    // tenants:state => state.tenants,
  },

  actions: {
    logout() {
      document.location.href = "/login";
    },
    async login({ commit }) {
      try {
        // var userClaims = auth.parseJwt(localStorage.idToken)
//        console.log(localStorage.idToken)
        axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.token}`;
        // commit("auth_success", userClaims);
      } catch (error) {
        commit("auth_error");
        delete localStorage.token
        delete localStorage.idToken
        delete axios.defaults.headers.common["Authorization"]
        throw error;
      }
    },
    // async setManager({commit}, value) {
    //   commit("set_manager", value)
    // },
    // async setLabUser({commit}, value) {
    //   commit("set_labuser", value)
    // },
    // async setTenants({commit}, value) {
    //   commit("set_tenants", value)
    // }
  }
};